import React, { useEffect, useRef, useState } from "react";
import "./NextGlobalImprovementsSurvey.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  updateSurveyData,
  updateSurveyPage,
} from "../../../../../redux/actions/survey";
import SurveyHero from "../../../../components/Survey/SurveyHero/SurveyHero";
import { Box } from "@mui/material";
import HealthConcernText from "../../../../components/Survey/HealthConcernText/HealthConcernText";
import getThemes from "../../../../../constants/colors/getTheme";
import Button from "../../../../components/Comon/Button/Button";
import LinkText from "../../../../components/Comon/LinkText/LinkText";
import {
  resetPopUp,
  setAppTheme,
  showPopup,
} from "../../../../../redux/actions/app";
import { createSurvey } from "../../../../../core/axios/services";
import { logoutUser } from "../../../../../redux/actions/user";
import Loader from "../../../../components/Loader/Loader";
import ScoreChangePromptModal from "../../../../components/Survey/ScoreChangePromptModal";

const NextGlobalImprovementsSurvey = ({
  showGlobalSnackbar,
  survey,
  i18n,
  app,
}) => {
  const [newScale, setNewScale] = useState(undefined);
  useEffect(() => {
   if(survey?.previousSurveyData?.scaleType || survey?.data?.scaleType){
      setNewScale((survey?.previousSurveyData?.scaleType ?? survey?.data?.scaleType) === 'zero_scale')
    }
  }, [survey]);


  const [concerns, setConcerns] = useState([]);
  const [themeColor, setThemeColor] = useState([]);
  const [scorePromptShown, setScorePromptShown] = useState(false);
  const scorePromptShownRef = useRef(false);
  const [scorePrompt, setScorePrompt] = useState({
    open: false,
    index: null,
    previousRate: null,
    currentRate: null,
  });

  const navigate = useNavigate();
  const { code } = useParams();
  const { previousId } = useParams();
  const dispatch = useDispatch();
  const [toSave, setToSave] = useState(false);

  const getOveralHealthForCurrentLanguage = () => {
    return survey?.settings?.clinic?.overallHealths.find(
      (item) => item.language.id === survey?.settings?.language?.id
    );
  };

  const initialConcerns = [
    {
      name: "overallCurrent",
      topText: getOveralHealthForCurrentLanguage()?.question1Subtitle,
      headline: getOveralHealthForCurrentLanguage()?.question1Title,
      text: i18n.t("youRatedItLastTime", {
        rate: survey.previousSurveyData.globalHealthOverallCurrent,
      }),
      lastTimeRate: survey.previousSurveyData.globalHealthOverallCurrent,
      leftOption: getOveralHealthForCurrentLanguage()?.question1LowScale,
      rightOption: getOveralHealthForCurrentLanguage()?.question1HighScale,
      concernRate:
        survey.data &&
        survey.data.globalHealth &&
        survey.data.globalHealth[7]?.concernRate !== undefined
          ? survey.data.globalHealth[7].concernRate
          : undefined,
      mandatory: false,
    },
    {
      name: "overallDesired",
      topText: getOveralHealthForCurrentLanguage()?.question2Subtitle,
      headline: getOveralHealthForCurrentLanguage()?.question2Title,
      text: i18n.t("youRatedItLastTime", {
        rate: survey.previousSurveyData.globalHealthOverallDesired,
      }),
      lastTimeRate: survey.previousSurveyData.globalHealthOverallDesired,
      leftOption: getOveralHealthForCurrentLanguage()?.question2LowScale,
      rightOption: getOveralHealthForCurrentLanguage()?.question2HighScale,
      concernRate:
        survey.data &&
        survey.data.globalHealth &&
        survey.data.globalHealth[8]?.concernRate !== undefined
          ? survey.data.globalHealth[8].concernRate
          : undefined,
      mandatory: false,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(updateSurveyPage(2));
    let rightConcerns = initialConcerns;
    let concernIndex = 0;
    survey.settings.bodyMetrics.reverse().forEach((metric, i) => {
      const index = rightConcerns.findIndex((c) => c.title === metric.title);
      if (index === -1) {
        let rate = 0;
        switch (concernIndex) {
          case 9:
            rate = survey.previousSurveyData.globalHealthNeck;
            break;
          case 8:
            rate = survey.previousSurveyData.globalHealthMidBack;
            break;
          case 7:
            rate = survey.previousSurveyData.globalHealthLowerBack;
            break;
          case 6:
            rate = survey.previousSurveyData.globalHealthPosture;
            break;
          case 5:
            rate = survey.previousSurveyData.globalHealthEnergyLevels;
            break;
          case 4:
            rate = survey.previousSurveyData.globalHealthAbilityStress;
            break;
          case 3:
            rate = survey.previousSurveyData.globalHealthSleepQuality;
            break;
          case 2:
            rate = survey.previousSurveyData.globalHealthImmuneSystem;
            break;
          case 1:
            rate = survey.previousSurveyData.globalHealthMentalState;
            break;
          case 0:
            rate = survey.previousSurveyData.globalHealthEmotionalState;
            break;
        }
        rightConcerns.unshift({
          name: metric.title,
          topText: metric.title,
          text: i18n.t("youRatedItLastTime", { rate: rate }),
          lastTimeRate: rate,
          headline: metric.question,
          concernRate:
            survey.data &&
            survey.data.globalHealth &&
            survey.data.globalHealth[i]?.concernRate !== undefined
              ? survey.data.globalHealth[i].concernRate
              : undefined,
          leftOption: metric.lowScaleName,
          rightOption: metric.highScaleName,
          mandatory: false,
          hasTextInput: false,
          hasRate: true,
        });
      }
      concernIndex++;
    });

    setConcerns(rightConcerns);

    if (survey.data == null) {
      survey.data = { globalHealth: rightConcerns };
    } else {
      survey.data.globalHealth = rightConcerns;
    }

    dispatch(updateSurveyData(survey.data));
    setScorePromptShown(false);
    scorePromptShownRef.current = false;
    setScorePrompt({
      open: false,
      index: null,
      previousRate: null,
      currentRate: null,
    });

    const activeQuestions = survey.settings.openEndedQuestions.filter(
      (o) => o.isActive === true
    ).length;
    if (activeQuestions === 0) {
      setToSave(true);
    }
  }, []);

  useEffect(() => {
    if (app.popupStatus === true) {
      switch (app.popUpData?.type) {
        case "completeSurvey":
          sendSurveyToApi();
          dispatch(resetPopUp());
          break;
      }
    } else if (app.popupStatus === false) {
      dispatch(resetPopUp());
    }

    setThemeColor(getThemes("mainColor", app.appTheme));
  }, [app]);

   const [isSendingSurveyToApi, setIsSendingSurveyToApi] = useState(false);
  const sendSurveyToApi = async () => {
    setIsSendingSurveyToApi(true);
    try {
      return await createSurvey(survey).then((res) => {
        setIsSendingSurveyToApi(false);
        dispatch(updateSurveyPage(5));
        navigate("/survey-next/" + code + "/" + previousId + "/thank-you");
      });
    } catch (error) {
      setIsSendingSurveyToApi(false);
      if (error.response.data.errorMessage) {
        showGlobalSnackbar(error.response.data.errorMessage);
      } else {
        showGlobalSnackbar(i18n.t("thereWasAnError"));
      }
    }
  };

  const save = () => {
    if (!checkIfBodyMetricsSelected()) {
      scrollTo();
      showGlobalSnackbar(i18n.t("pleaseCompleteBodyMetrics"), 2000);
      return;
    }
    const data = {
      showPopup: true,
      data: {
        title: i18n.t("confirmCompleteSurvey"),
        confirmButton: i18n.t("confirmCompleteSurveyButton"),
        denyButton: i18n.t("denyCompleteSurveyButton"),
        type: "completeSurvey",
      },
    };
    dispatch(showPopup(data));
  };

  const checkIfBodyMetricsSelected = () => {
    if (
      concerns[0]?.concernRate !== undefined && concerns[0]?.concernRate !== null &&
      concerns[1]?.concernRate !== undefined && concerns[1]?.concernRate !== null &&
      concerns[2]?.concernRate !== undefined && concerns[2]?.concernRate !== null &&
      concerns[3]?.concernRate !== undefined && concerns[3]?.concernRate !== null &&
      concerns[4]?.concernRate !== undefined && concerns[4]?.concernRate !== null &&
      concerns[5]?.concernRate !== undefined && concerns[5]?.concernRate !== null &&
      concerns[6]?.concernRate !== undefined && concerns[6]?.concernRate !== null &&
      concerns[7]?.concernRate !== undefined && concerns[7]?.concernRate !== null &&
      concerns[8]?.concernRate !== undefined && concerns[8]?.concernRate !== null &&
      concerns[9]?.concernRate !== undefined && concerns[9]?.concernRate !== null &&
      concerns[10]?.concernRate !== undefined && concerns[10]?.concernRate !== null &&
      concerns[11]?.concernRate !== undefined && concerns[11]?.concernRate !== null
    ) {
      return true;
    }
  };

  const nextPage = () => {
    if (!checkIfBodyMetricsSelected()) {
      scrollTo();
      showGlobalSnackbar(i18n.t("pleaseCompleteBodyMetrics"), 2000);
      return;
    }
    dispatch(updateSurveyPage(3));
    navigate(
      "/survey-next/" + code + "/" + previousId + "/health-improvements"
    );
  };

  const previousPage = () => {
    dispatch(updateSurveyPage(1));
    navigate("/survey-next/" + code + "/" + previousId + "/health-concerns");
  };

  const updateConcern = (index, value, type) => {
    const nextConcerns = concerns.map((concern, concernIndex) =>
      concernIndex === index
        ? {
            ...concern,
            [type === "text" ? "concern" : "concernRate"]: value,
          }
        : concern
    );

    if (type === "rate" && !scorePromptShownRef.current) {
      const previousRate = Number(nextConcerns[index]?.lastTimeRate);
      const currentRate = Number(value);
      const hasValidRates =
        Number.isFinite(previousRate) && Number.isFinite(currentRate);
      const concernScaleVariant = isBodyMetricConcern(nextConcerns[index]?.name)
        ? globalImprovementsScaleVariant
        : "regular";
      const hasNegativeSwing =
        hasValidRates &&
        concernScaleVariant === "red_to_green" &&
        previousRate - currentRate >= 2;

      if (hasNegativeSwing) {
        scorePromptShownRef.current = true;
        setScorePromptShown(true);
        setConcerns(nextConcerns);
        setScorePrompt({
          open: true,
          index,
          previousRate,
          currentRate,
        });
        return;
      }
    }

    setConcerns(nextConcerns);

    if (survey.data == null) {
      survey.data = { globalHealth: nextConcerns };
    } else {
      survey.data.globalHealth = nextConcerns;
    }
    dispatch(updateSurveyData(survey.data));
  };

  const closeScorePrompt = () => {
    if (survey.data == null) {
      survey.data = { globalHealth: concerns };
    } else {
      survey.data.globalHealth = concerns;
    }
    dispatch(updateSurveyData(survey.data));
    setScorePrompt((prev) => ({ ...prev, open: false }));
  };

  const changeScoreAnswer = () => {
    if (scorePrompt.index === null || scorePrompt.index === undefined) {
      closeScorePrompt();
      return;
    }

    const nextConcerns = concerns.map((concern, concernIndex) =>
      concernIndex === scorePrompt.index
        ? { ...concern, concernRate: undefined }
        : concern
    );

    setConcerns(nextConcerns);

    if (survey.data == null) {
      survey.data = { globalHealth: nextConcerns };
    } else {
      survey.data.globalHealth = nextConcerns;
    }
    dispatch(updateSurveyData(survey.data));
    closeScorePrompt();
  };

  const scrollTo = () => {
    const element = document.getElementById(concerns[0].name);
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  const isBodyMetricConcern = (concernName) =>
    !["howLongToAchieve", "markThings"].includes(concernName);
  const globalImprovementsScaleVariant = "red_to_green";

  return (
    <div className="ThirdScreenSurvey">
      <ScoreChangePromptModal
        open={scorePrompt.open}
        previousRate={scorePrompt.previousRate}
        currentRate={scorePrompt.currentRate}
        onConfirm={closeScorePrompt}
        onChangeAnswer={changeScoreAnswer}
      />
      <SurveyHero
        // step={i18n.t("step") + " 2"}
        headline={getOveralHealthForCurrentLanguage()?.nextTitle}
        text={getOveralHealthForCurrentLanguage()?.nextDesc}
        videoLink={getOveralHealthForCurrentLanguage()?.nextVideoUrl}
        buttonText={i18n.t("next")}
        clickedButton={() => scrollTo()}
        app={app}
        surveyType={survey?.settings?.type}
      />

      <div className={"concernsContainer"}>
        {concerns.map((concern, index) => {
          return (
            <div className={"concernContainer"} key={index}>
              <HealthConcernText
                  newScale={newScale}
                scaleVariant={
                  isBodyMetricConcern(concern.name)
                    ? globalImprovementsScaleVariant
                    : "regular"
                }
                setConcernText={(value) => updateConcern(index, value, "text")}
                setConcernRate={(value) => updateConcern(index, value, "rate")}
                mandatory={concern.mandatory}
                text={concern.text}
                concernRate={concern.concernRate}
                topText={concern.topText}
                headline={concern.headline}
                themeColor={themeColor}
                hasTextInput={false}
                leftOption={concern.leftOption}
                rightOption={concern.rightOption}
                id={concern.name}
                i18n={i18n}
                lastTimeRate={concern.lastTimeRate}
              />
            </div>
          );
        })}
      </div>
      {
          isSendingSurveyToApi && <Loader/>
      }
      <div className={"buttonsContainer"}>
        {toSave ? (
          <div className={"nextContainer"} onClick={() => save()}>
            <Button
                disabled={isSendingSurveyToApi}
              color={themeColor}
              mode={"small"}
              text={i18n.t("completeSurvey")}
            />
          </div>
        ) : (
          <div className={"nextContainer"} onClick={() => nextPage()}>
            <Button
                disabled={isSendingSurveyToApi}
              color={themeColor}
              mode={"small"}
              text={i18n.t("next")}
            />
          </div>
        )}
        <div className={"previousContainer"} onClick={() => previousPage()}>
          <LinkText text={i18n.t("previous")} />
        </div>
      </div>
    </div>
  );
};

export default NextGlobalImprovementsSurvey;
